var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-card',{staticClass:"d-flex align-center justify-center",attrs:{"min-height":`${_vm.heightCard}vh`,"width":`${_vm.widthCard}%`,"flat":""}},[_c('v-progress-circular',{attrs:{"size":_vm.sizeProgress,"width":_vm.widthProgress,"color":_vm.color,"indeterminate":""}})],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }